import { useForm } from "../useForm";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../controls/Input";
import DatePickerInput from "../../controls/DatePickerInput";
import SelectMenu from "../../controls/SelectMenu";

const initialFValues = {
  name: "",
  address: "",
  campaign_user: null,
  product: null,
};

export default function CreateCampaignForm(props) {
  const { setOpen, actionCall, productsForDropdown, campaignUsersForDropdown } = props;
  const { values, handleInputChange } = useForm(initialFValues, false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...values,
      product_id: values.product?.value || null,
      campaign_user_id: values.campaign_user?.value ?? null,
    };
    delete payload.product;
    delete payload.campaign_user;
    actionCall(payload);
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl"
    >
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <h2 className="text-base font-semibold leading-6 text-gray-900">
              Add new campaign
            </h2>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div className="mt-2">
            <Input
              label="Store Name"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Store Address"
              name="address"
              onChange={handleInputChange}
              value={values.address}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>

          <div className="mt-2">
            <SelectMenu
              name="campaign_user"
              handleInputChange={handleInputChange}
              options={campaignUsersForDropdown ?? []}
              title="Employee"
              value={values.campaign_user}
              placeholder="Select employee"
            />
            {values.campaign_user && (
              <p className="mt-1 text-xs text-gray-500">
                PIN: {values.campaign_user.pin ?? "—"}
              </p>
            )}
          </div>
          <div className="mt-2">
            <SelectMenu
              handleInputChange={handleInputChange}
              name="product"
              options={productsForDropdown}
              title={"Product"}
              defaultValue={null}
              showLabel={true}
              placeholder=""
            />
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Add campaign
        </button>
      </div>
    </form>
  );
}
